import React, { useState, useEffect } from "react";
import {
  createAnalytics,
  getAnalytics,
  editAnalytics,
  publishAnalytics,
  requestPublish,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { NecStore } from "../../store/necStore";
import { UserStore } from "../../store/userStore";
// import ToolTip from "../tooltip/tooltip";
// import { UserLang } from "../../store/userStore";

const Analytics = (props) => {
  const initState = {
    web: "",
    android: "",
    iOS: "",
    androidTv: "",
    appleTv: "",
    fireTv: "",
    roku: "",
    samsungTizen: "",
    lgWebOs: "",
    chromecast: "",
  };

  const [analyticSchema, setAnalytic] = useState(initState);
  const user = UserStore.useState((s) => s.user);
  const role = NecStore.useState((s) => s.setting);
  const [analyticCount, setAnalyticCount] = useState("");
  const [analyticStatus, setAnalyticStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  // const lan = UserLang.useState((s) => s.lan);
  const [lan] = useState("ltr");

  const handleChange = (evt) => {
    const value = evt.target.value;
    setAnalytic({
      ...analyticSchema,
      [evt.target.name]: value,
    });
  };
  /*   const updateVisiblity = (event)=>{
    if(event.target.name==="customSwitch1")
    {
        const type= "allowLogin"
        setAnalytic({
            ...analyticSchema,
            [type]: event.target.checked
          });
    }
    if(event.target.name==="customSwitch2")
    {
        const type= "allowSubscription"
        setAnalytic({
            ...analyticSchema,
            [type]: event.target.checked
          });
    }
    
  } */

  useEffect(() => {
    const colorDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getAnalytics().then(
        (result) => {
          setAnalytic(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setAnalyticCount(obj.message);
          setAnalyticStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    colorDetail();
  }, []);

  const setNotifications = async (editing) => {
    const result = await requestPublish(editing).then(
      (result) => {},
      (error) => {
        toastr.error("Unable to Load Data", "Error");
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const handlePublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: null,
      itemid: null,
      redirect: "analytics",
      message: "Content Editor requested to Publish Analytics",
    };
    setNotifications(opt);
  };

  const colorSave = async (event) => {
    setLoading(true);
    event.preventDefault();
    if (
      analyticStatus === 404 ||
      analyticCount === "No Analytics Schema Exists"
    ) {
      /* eslint-disable no-unused-vars */
      const result = await createAnalytics(analyticSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editAnalytics(analyticSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();
      /* eslint-disable no-unused-vars */
      const result = await publishAnalytics().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Analytics Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Web
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="web"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.web}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Android
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="android"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.android}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            iOS
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="iOS"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.iOS}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Android TV
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="androidTv"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.androidTv}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Apple TV
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="appleTv"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.appleTv}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Fire TV
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="fireTv"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.fireTv}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Roku
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="roku"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.roku}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Samsung Tizen
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="samsungTizen"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.samsungTizen}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            LG Web OS
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="lgWebOs"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.lgWebOs}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            chromecast
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="chromecast"
                            className="form-control inside-form"
                            placeholder="Tracking ID"
                            defaultValue={analyticSchema.chromecast}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "btn-group btn-group-md float-left"
                              : "btn-group btn-group-md float-right"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          {role.RFP === true && user.editor === true ? (
                            <button
                              type="#!"
                              onClick={handlePublishRequest}
                              className={
                                lan === "rtl"
                                  ? "float-right btn btn-success"
                                  : "float-left btn btn-success"
                              }
                              style={{ width: "100px", marginRight: "6px" }}
                              disabled={
                                !role.production === true ? true : false
                              }
                              hidden={!role.production === true ? true : false}
                            >
                              Request to Publish
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={publish}
                              className="btn btn-success"
                              style={{ width: "100px", marginRight: "6px" }}
                              disabled={
                                !role.production === true ? true : false
                              }
                              hidden={!role.production === true ? true : false}
                            >
                              Publish
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Analytics;
